<template>
  <div class="emap-flow-next-step" v-if="visible">
    <div class="emap-flow-next-step-item"  v-if="cur_node_info.nodeName" >
      <label class="emap-flow-item-label">{{labels.cur_node}}</label>
      <div class="emap-flow-item-content" >
        <div class="next-node-desc">{{cur_node_info.nodeName}}</div>
      </div>
    </div>
    <div class="emap-flow-next-step-item" v-if="cur_node_info.documentation">
      <label class="emap-flow-item-label">{{labels.cur_node_desc}}</label>
      <div class="emap-flow-item-content" >
        <div class="next-node-desc">{{cur_node_info.documentation}}</div>
      </div>
    </div>
    <div class="emap-flow-next-step-item" v-if="showNextNode">
      <label class="emap-flow-item-label">{{nodelabel || labels.node}}</label>
      <div class="emap-flow-item-content">
        <Select v-model="node" :disabled="node_list.length === 1" @on-change="$_nodeChange" @on-open-change="$_getCustomNode" :loading="loading" ref="nextNode" transfer :placeholder="nodeplaceholder" @on-query-change="queryChange('nextNode')">
          <Option v-for="item in node_list" :value="item.nodeId" :key="item.nodeId">{{ item.nodeName }}</Option>
        </Select>
      </div>
    </div>
    <div class="emap-flow-next-step-item" v-if="showNextNode && cur_node.documentation && schema ==='default'">
      <label class="emap-flow-item-label">{{labels.node_desc}}</label>
      <div class="emap-flow-item-content" >
        <div class="next-node-desc">{{cur_node.documentation}}</div>
      </div>
    </div>
    <div class="emap-flow-next-step-item" v-if="$slots.customItem">
      <slot name="customItem"></slot>
    </div>
    <!-- 下一步处理人 -->
    <div class="emap-flow-next-step-item" v-if="cur_node.isEndNode !== '1' && showNextAssignees && !isMultiInstance">
      <label class="emap-flow-item-label">{{assigneeslabel || labels.assignee}}</label>
      <div class="emap-flow-item-content">
        <Select v-model="assignees" v-if="assignee_list.length && echostyle != 'tree'" :disabled="!cur_node.nodeId" @on-change="emitInput" ref="nextAssignees" :placeholder="assigneeplaceholder" :multiple="multiple" @on-query-change="queryChange('nextAssignees')" transfer filterable clearable>
          <Option v-for="item in assignee_list" :value="item.userId" :key="item.userId">{{ item.display }}</Option>
        </Select>
        <div class="custom-next-asssignees-select" v-else @click="$_customSelect" :class= "[{disabled:!cur_node.nodeId && showNextNode}]">
         
            <Tag closable v-for="(item,index) in customNextAssigneesList" :name="item.id" :key="index" @on-close="$_customOptionClose(item,index)">{{item.display}}</Tag>
          
        </div>
      </div>
    </div>

    <!-- 添加办理人 -->
    <div class="emap-flow-next-step-item" v-if="cur_node.isEndNode !== '1' && showNextAssignees && !isMultiInstance && allowAddAssignee && !addAssigneeHidden">
      <label class="emap-flow-item-label">{{ labels.addAssignee}}</label>
      <div class="emap-flow-item-content">
        <div class="custom-next-asssignees-select" @click="clickAddAssignee" :class= "[{disabled:!cur_node.nodeId && showNextNode}]">
         
            <Tag closable v-for="(item,index) in addAssigneesList" :name="item.id" :key="index" @on-close="$_addOptionClose(item,index)">{{item.display}}</Tag>
          
        </div>
      </div>
    </div>

    <!-- 下一步处理组 -->
    <div class="emap-flow-next-step-item" v-if="cur_node.isEndNode !== '1' && showNextAssignees && isMultiInstance">
      <label class="emap-flow-item-label">{{labels.assigneeGroup}}</label>
      <div class="emap-flow-item-content">
        <Select v-model="assignees" :disabled="!cur_node.nodeId" @on-change="emitInput" ref="nextAssignees" :placeholder="assigneeplaceholder" multiple transfer filterable clearable @on-query-change="queryChange('nextAssignees')">
          <Option v-for="item in assignee_list" :value="item.userId" :key="item.userId">{{ item.display }}</Option>
        </Select>
      </div>
    </div>
      
    <div class="emap-flow-next-step-item" v-if="hasCirculate">
      <label class="emap-flow-item-label">{{labels.circulator}}</label>
      <div class="emap-flow-item-content" >
        <Select v-model="circulators" @on-change="emitInput" :placeholder="$LocalH5('nextStep.selectPlaceholder')" multiple transfer filterable clearable v-if="circulatorSelectFalg">
          <Option v-for="item in circulator_list" :value="item.userId" :key="item.userId">{{ item.display }}</Option>
        </Select>
        <div class="custom-next-asssignees-select" v-if="!circulatorSelectFalg" @click="$_customCirculatorSelect">
         
            <Tag closable v-for="(item,index) in customCirculatorList" :name="item.id" :key="index" @on-close="$_customCirculatorLOptionClose(item,index)">{{item.display}}</Tag>
          
        </div>
      </div>
    </div>
    <emap-flow-pick v-model="showpick" :multiple="multiple" :options="assignees" @on-confirm="$_emapflowPick" :users="assignee_list" :filter="echostyle === 'tree'"></emap-flow-pick>
    <emap-flow-pick v-model="showpickAdd" :multiple="multiple" :options="assigneesAdd" @on-confirm="configAddAssignee"></emap-flow-pick>
    <emap-flow-pick v-model="showcirculatorpick" multiple :options="circulators" @on-confirm="$_emapflowPick"></emap-flow-pick>
  </div>
</template>
<script>
  import NextStepMixin from "mixins/emapflow-next-step"
  import EmapFlowPick from './emap-flow-pick.vue'
  export default {
    name: "emap-flow-next-step",
    components: {
      EmapFlowPick
    },
    data() {
      return {
        customNextAssigneesList: [],
        addAssigneesList: [], 
        customCirculatorList: [],
        showpick: false,
        showpickAdd:false,
        showcirculatorpick: false,
        emapflowpickFlag: null,  // 'assignee'/'circulator'
        loading: false,
        timeout:{
          nextNode:null,
          nextAssignees:null,

        }
      }
    },
    props: {
      nodeplaceholder: String,
      assigneeplaceholder: String
    },
    mixins: [NextStepMixin],
    methods: {
      // YBT2-1406 过滤时下拉控件下拉选项位置不对 22-4-21 wangyuan
      queryChange(refName) {
        var nextVM = this.$refs[refName]
        if(nextVM && nextVM.visible) {
          nextVM.visible = false;
        }
        if(this.timeout[refName]){
          clearTimeout(this.timeout[refName])
        }
        this.timeout[refName] = setTimeout(function() {
          nextVM.visible = true
        }, 150)
      },
      $_nodeChange(nodeId) {
        this.$emit('node-change', nodeId);
        // 获取节点下的描述信息
        this.cur_node = this.node_list.filter(node => {
          return node.nodeId === nodeId
        })[0] || {};
        this.emitInput();
        // 组件默认模式
        if(this.showNextAssignees) {
          this.assignees = [];
          this.assigneesAdd = [];
          this.assignee_list = [];
          this.customNextAssigneesList = [];
          this.addAssigneesList = []
          nodeId && this.getAssignees();
        }
      },
      $_getCustomNode(value) {
        if(this.schema == 'simple' && value && !this.node_list.length) {
          this.loading = true;
          this.getNextNodes();
        }
      },
      $_customSelect() {
        if(!this.cur_node.nodeId && this.showNextNode) return;
        if(this.asyncAssignee) {
          this.toastMsg(this.$LocalH5('nextStep.getHandlerTips'));
          return
        }
        // 判断是否为自定义选人模式
        if(!this.defaultCustom){
          this.$emit("custom-select", this.cur_node.nodeId, this.cur_node);
        } else {
          this.showpick = true;
          this.emapflowpickFlag = 'assignee';
        }  
      },
      clickAddAssignee(){
        if(!this.cur_node.nodeId && this.showNextNode) return;
        if(this.asyncAssignee) {
          this.toastMsg(this.$LocalH5('nextStep.getHandlerTips'));
          return
        }
        this.showpickAdd = true;
      },
      $_customOptionClose(item, index) {
        this.customNextAssigneesList.splice(index,1);
        if(!this.defaultCustom){
          this.$emit('custom-option-delete', item, index);
        } else {
          this.assignees.splice(index,1);
          this.emitInput();
        }
      },
      $_addOptionClose(item, index) {
        this.addAssigneesList.splice(index,1);
        // if(!this.defaultCustom){
        //   this.$emit('custom-option-delete', item, index);
        // } else {
          this.assigneesAdd.splice(index,1);
          this.emitInput();
        // }
      },
      $_customCirculatorLOptionClose(item, index) {
        this.customCirculatorList.splice(index,1);
        this.circulators.splice(index,1);
        this.emitInput();
      },
      $_customSetValues(options) {
        options = options && Object.prototype.toString.call(options) === '[object Array]' ? options : [];
        var ids = options.map((option) => {
          return option.id;
        });
        this.assignee_list = [];
        this.assignees = ids;
        this.emitInput();
      },
      $_customCirculatorSelect() {
        this.showcirculatorpick = true;
        this.emapflowpickFlag = 'circulator';
      },
      $_emapflowPick(ids, options) {
        options = options.map((item) => {
          item.id = item.id || item.userId;
          item.name = item.name || item.userName;
          return item;
        });
        if(this.emapflowpickFlag === 'assignee') {
          this.assignees = ids;
          this.customNextAssigneesList = this.setEchoStyle(options, { "userId": "id", "userName": "name", "deptName": "deptName" })
        } else if(this.emapflowpickFlag === 'circulator') {
          this.circulators = ids;
          this.customCirculatorList = this.setEchoStyle(options, { "userId": "id", "userName": "name", "deptName": "deptName" })
        }
        this.emapflowpickFlag = null;
        this.emitInput();
      },
      configAddAssignee(ids, options){
        options = options.map((item) => {
          item.id = item.id || item.userId;
          item.name = item.name || item.userName;
          return item;
        });
          
        this.assigneesAdd = ids;
        this.addAssigneesList = this.setEchoStyle(options, { "userId": "id", "userName": "name", "deptName": "deptName" })
        
        this.emitInput();
      },

      /**
       * 联动表单，表单相关数据变更触发。当且仅流程设计器已配置下一步节点时，刷新下一步组件  (需求来自王志伟2019/4/24)
       */
      linkFormChange(formdata, callback) {
        if(!this.isFinishedTask && this.showNextNode) {
          this.node = null;
          this.cur_node = {};
          this.node_list = [];
          this.assignees = [];
          this.assigneesAdd = [];
          this.assignee_list = [];
          this.customNextAssigneesList = [];
          this.addAssigneesList = []
          this.getNextNodes(formdata, callback);
        } else {
          callback && callback();
        }
      },
      updateNextAssignees(formdata, callback) {
        if(!this.isFinishedTask && this.showNextAssignees && this.cur_node.nodeId) {
          this.assignees = [];
          this.assigneesAdd = [];
          this.assignee_list = [];
          this.customNextAssigneesList = [];
          this.addAssigneesList = []
          this.getAssignees(formdata, callback);
        } else {
          callback && callback();
        }
      },
      /**
       * 校验说明：根据下一步节点、下一步办理人的显示/不显示来确定是否校验
       */
      validate() {
        let result = this.validateDefault();
        if(!result.valid) this.toastMsg(result.msg);
        return result.valid
      },
      toastMsg(msg, type) {
        type = type || "warning";
        this.$Message[type](msg);
      },
      scrollFunc(event) {
        if(event.target.nodeName === "LI") return;
        var nextNodeVM = this.$refs.nextNode;
        if(nextNodeVM && nextNodeVM.visible) {
          nextNodeVM.visible = false;
        }
        var nextAssigneesVM = this.$refs.nextAssignees;
        if(nextAssigneesVM && nextAssigneesVM.visible) {
          nextAssigneesVM.visible = false;
        }
      }
    },
    mounted() {
      // 监听页面滚动
      if (document.addEventListener) {
        document.addEventListener('DOMMouseScroll', this.scrollFunc, false);
      } //FireFox
      window.onmousewheel = document.onmousewheel = this.scrollFunc; //IE/Opera/Chrome
    }
  }
</script>
<style scoped>
  .emap-flow-next-step {
    border: 1px solid #dcdee2;
    background-color: #fff;
    font-size: 14px;
    box-sizing: border-box;
  }
  .emap-flow-next-step .emap-flow-next-step-item:not(:last-child) {
    border-bottom: 1px solid #dcdee2;
  }
  .emap-flow-next-step-item:after {
    content: '';
    display: table;
    clear: both;
  }
  .emap-flow-item-label {
    float: left;
    text-align: left;
    vertical-align: middle;
    width: 130px;
    height: 36px;
    line-height: 36px;
    padding: 0px 2px 0px 16px;
  }
  .emap-flow-item-content {
    margin-left: 130px;
    padding: 2px 2px 2px 12px;
    border-left: 1px solid #dcdee2;
  }
  .emap-flow-item-content > div {
    max-height: 100px;
    overflow: auto;
  } 
  .emap-flow-item-content:before {
    display: table;
    content: '';
  }
  .custom-next-asssignees-select {
    min-height: 32px;
    position: relative;
    cursor: pointer;
    background-color: #fff;
    border-radius: 4px;
    padding:0 4px;
    border: 1px solid #dddee1;
  }
  .custom-next-asssignees-select.disabled {
    background-color: #f3f3f3;
    cursor: not-allowed;
    color: #ccc;
  }
  .custom-next-asssignees-select .ivu-tag{
    height: 24px;
    line-height: 22px;
    margin: 3px 4px 3px 0;
  }
  .next-node-desc {
    min-height: 32px;
    line-height: 1.5;
    padding: 4px 7px;
    font-size: 14px;
    word-break: break-all;
    color: #515a6e;
    background-color: #fff;
    background-image: none;
    position: relative;
    cursor: text;
    transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
  }
</style>